import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'

import { reducer as location } from '@/state/routes'
import auth from '@/state/reducers/auth'
// import routesMap from '@/state/routesMap'
import locale from '@/state/reducers/locale'
import rest from '@/state/reducers/rest'
import ui from './ui'

import resources from '@/state/resources'

import { LOGOUT } from '@/state/types/auth'

// const resources = Object.keys(routesMap)
//   .filter(route => routesMap[route].resource)
//   .map(route => ({ name: routesMap[route].resource, options: routesMap[route].options || [] }))

const appReducer = combineReducers({
  auth,
  rest: rest(resources),
  location,
  form,
  locale: locale('en'),
  ui,
})

export const resettableAppReducer = (state, action) =>
  appReducer(action.type !== LOGOUT ? state : undefined, action)



// WEBPACK FOOTER //
// ./state/reducers/index.js